import { motion } from "motion/react";
import React, { CSSProperties } from "react";
import { useTheme } from "styled-components";

export enum Position {
  TOP = "top",
  BOTTOM = "bottom",
}

interface RequiredFieldMessageProps {
  requirement: boolean;
  errorMessage: string;
  position?: Position;
  style?: CSSProperties;
}

const RequiredFieldMessage = ({
  requirement,
  errorMessage,
  position = Position.BOTTOM,
  style,
}: RequiredFieldMessageProps) => {
  const appTheme = useTheme();
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={
        requirement
          ? { opacity: 1, y: 0 }
          : { opacity: 0, y: position === Position.BOTTOM ? -10 : 10 }
      }
      transition={{ ease: "easeInOut", duration: 0.3 }}
      style={{
        color: appTheme.colors.red,
        display: requirement ? "block" : "none",
        ...style,
      }}
    >
      {errorMessage}
    </motion.div>
  );
};

export default RequiredFieldMessage;
